import { useEffect, useMemo } from 'react';
import { Pass } from '../../../shared/types';
import { chunk, isEmpty } from 'lodash';
import { usePageState } from '../../../Hooks/usePageState';
import { useGetFinancialOverviewQuery } from '../../../GraphQL/hooks/useFinancialOverviewQuery';
import { useOverviewLinkState } from '../linkstate/financialOverview.linkstate';

const pageSize = 10;
const getPageCount = (passes: Pass[]) => Math.ceil(passes?.length / pageSize);
const getCurrentPage = (requestedPage: number, passes: Pass[]) => {
    const pageCount = getPageCount(passes);
    return requestedPage < 1 ? 1 : requestedPage > pageCount ? pageCount : requestedPage;
};

export const useSortedFinancialoverviewQuery = () => {
    const { setLoading } = usePageState();
    const [state, setState] = useOverviewLinkState();
    const { page } = state;

    const { data: unsortedFinancialOverview, refetch, loading } = useGetFinancialOverviewQuery();
    useEffect(() => setLoading(loading), [loading]);

    const setPage = (newPage: number) => {
        const pageCount = getPageCount(unsortedFinancialOverview);
        // console.log('new page', newPage, pageCount);
        const page = newPage < 1 ? 1 : newPage > pageCount ? pageCount : newPage;
        setState({ ...state, page });
    };

    const { pageCount, totalCount, sortedFinancialOverview } = useMemo(() => {
        const totalCount = unsortedFinancialOverview?.length ?? 0;
        const pageCount = getPageCount(unsortedFinancialOverview);
        const sortedFinancialOverview = chunk(unsortedFinancialOverview, pageSize);

        return { totalCount, pageCount, sortedFinancialOverview };
    }, [unsortedFinancialOverview]);

    const currentPage = getCurrentPage(page, unsortedFinancialOverview);

    return {
        sortedFinancialOverview: sortedFinancialOverview?.length > 0 ? sortedFinancialOverview[currentPage - 1] : [],
        refetch: () => refetch(),
        page: page ?? 1,
        pageCount,
        totalCount,
        pageSize,
        setPage,
        loading,
    };
};
